import { Component, OnInit } from '@angular/core';
import { Inject } from '@angular/core';
import { UserService } from 'src/app/services/core/user/user.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { IUserRoleDetails } from 'src/app/models/user-role-details';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ConfigurationSettings } from 'src/app/models/configuration.settings';
import { startWith, map, debounceTime, tap, switchMap, finalize } from 'rxjs/operators';
import { IRoles } from 'src/app/models/roles';
import { ActivatedRoute } from '@angular/router';
import { ToasterService } from '../../../services/shared/toaster/toaster.service';
import { MatDialog } from '@angular/material';
import { WarningPopupComponent } from '../../shared/warning-popup/warning-popup.component';

@Component({
  selector: 'app-userrolemanagement',
  templateUrl: './userrolemanagement.component.html',
  styleUrls: ['./userrolemanagement.component.scss']
})
export class UserrolemanagementComponent implements OnInit {
  paginationPageSize = 50;
  newUserRoleForm: FormGroup;
  UserName: FormControl;
  Role: FormControl;
  UserType: FormControl;
  roles: IRoles[] = [];
  userRoles: IUserRoleDetails[] = [];
  botConfigId: number;
  botData: any;
  selectedRole: string = '';
  private _subscriptions = new Subscription();
  isSearching: boolean;
  filteredOptions: any;
  private gridApi;
  private gridColumnApi;
  columnDefs: any[] = [];
  sortingOrder;
  defaultColDef;
  addUserRole: boolean = false;
  userType: string;
  selectedUserId: string;
  UserManagement: any;
  isRoleValidForUser: boolean = true;
  constructor(private userService: UserService,
    private toasterService: ToasterService,
    private toastr: ToastrService,
    private http: HttpClient,
    private configurationSettings: ConfigurationSettings,
    private route: ActivatedRoute,
    private dialogWarning: MatDialog) {
    this.isSearching = false;
  }
  rowData = [];
  ngOnInit() {
    this.botData = JSON.parse(sessionStorage.getItem('botData'));
    this.botConfigId = this.botData.botConfigId;
    this.createColumnDefs();
    this.UserType = new FormControl('', Validators.required)
    this.UserName = new FormControl({ value: '', disabled: true }, Validators.compose([Validators.required, Validators.maxLength(50), Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/)]))
    this.Role = new FormControl({ value: '', disabled: true }, Validators.required)

    this.newUserRoleForm = new FormGroup({
      UserName: this.UserName,
      Role: this.Role,
      UserType: this.UserType
    })

    this._subscriptions.add(
      this.userService.getRoles()
        .subscribe(
          res => {
            this.roles = res;
            this.getAllUserRoles(this.botConfigId);
          },
          (error) => {
            this.toasterService.error("Unable to retrieve Roles");
          }
        )
    )
  }

  getAllUserRoles(botConfigId: number) {
    this._subscriptions.add(
      this.userService.getAllUserRoles(botConfigId)
        .subscribe(
          res => {
            this.rowData = res;
          },
          (error) => {
            this.toasterService.error("Unable to retrieve User-Roles");
          }
        )
    )
  }

  onItemChange(Value) {
    this.userType = this.newUserRoleForm.value.UserType;
    this.UserName.setValue("");
    this.Role.setValue("");
    this.UserName.enable();
    this.Role.enable();
    this.peoplePickerFn();
  }

  onSelectionChanged(selectedUser) {
    this.selectedUserId = selectedUser;
  }

  peoplePickerFn() {
    this.UserName.valueChanges.subscribe(newValue => {
      this.UserManagement = { UserName: newValue, UserType: this.userType }
    });
    this.UserName.valueChanges
      .pipe(
        debounceTime(300),
        map(value => value ? typeof value === 'string' ? value.length >= 3 ? value : [] : value.emailAddress : []),
        tap(() => {
          this.filteredOptions = [];
          this.isSearching = true;
        }),
        switchMap(value => this.http.post(this.configurationSettings.user_api_endpoint + "/GetMatchingUsers", this.UserManagement)
          .pipe(
            finalize(() => {
              this.isSearching = false
            }),
          )
        )
      )
      .subscribe(data => {
        if (data) {
          this.filteredOptions = data;
        }
      });
  }

  registerUserSave(formValues) {
    this.userRoles = [];
    if (this.selectedUserId != formValues.UserName) {
      this.toasterService.error("Invalid user");
    }
    else {
      //this.spinner.show();
      for (let i = 0; i < formValues.Role.length; i++) {
        this.userRoles[i] = {
          botConfigId: this.botConfigId,
          username: formValues.UserName,
          userId: 0,
          roleId: this.roles.findIndex(item => item.displayName === formValues.Role[i]) > -1 ? this.roles[this.roles.findIndex(item => item.displayName === formValues.Role[i])].id : 0,
          role: formValues.Role[i],
          firstname: "",
          lastname: "",
          isExternal: formValues.UserType == 'External' ? true : false,
          privacyStatementFlag: true
        };

        if (formValues.Role[i].toLowerCase() === "chat manager") {
          let isAgentOrSA = this.rowData.find(ob => ob.username.toLowerCase() === formValues.UserName.toLowerCase() && (ob.role.toLowerCase().includes("agent") || ob.role.toLowerCase().includes("senior agent")));
          if (isAgentOrSA || isAgentOrSA != null) {
            this.isRoleValidForUser = false;
          }
        }
        else if (formValues.Role[i].toLowerCase() === "agent" || formValues.Role[i].toLowerCase() === "senior agent") {
          let isChatManager = this.rowData.find(ob => ob.username.toLowerCase() === formValues.UserName.toLowerCase() && ob.role.toLowerCase().includes("chat manager"));
          if (isChatManager || isChatManager != null) {
            this.isRoleValidForUser = false;
          }
        }
        else {
          this.isRoleValidForUser = true;
        }
      }

      let data = this.rowData.find(ob => ob.username.toLowerCase() === formValues.UserName.toLowerCase() && ob.role === formValues.Role[0]);

      if (this.isRoleValidForUser === false) {
        this.toasterService.error("Selected user role(s) conflicts with existing roles for the user.");
      }
      else {
        if (!data || data === null) {
          this.addUserRole = true;
          this._subscriptions.add(
            this.userService.addUserRoles(this.userRoles)
              .subscribe(
                res => {
                  this.toasterService.success("Successfully added User role");
                  this.newUserRoleForm.markAsUntouched();
                  this.newUserRoleForm.reset();
                  this.rowData = res;
                  this.UserName.disable();
                  this.Role.disable();
                  this.peoplePickerFn();
                  this.addUserRole = false;
                },
                (error) => {
                  this.addUserRole = false;
                }
              )
          )
        }
        else {
          this.toasterService.error("User role mapping already exists");
        }
      }
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }


  createColumnDefs() {
    const customComparator = (valueA, valueB) => {
      valueA = valueA ? valueA : '';
      valueB = valueB ? valueB : '';
      return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
    };
    const columnDefs = [
      { headerName: 'User', field: 'username', width: 200, comparator: customComparator, filter: true, sortable: true, sortingOrder: ["asc", "desc"] },
      { headerName: 'Role', field: 'role', width: 100, comparator: customComparator, filter: true, sortable: true, sortingOrder: ["asc", "desc"] },
      { headerName: 'Delete', width: 90, cellRenderer: this.deleteCellRenderer.bind(this) },
    ]
    this.columnDefs = columnDefs;
  }

  deleteCellRenderer(userRole: any) {
    const element = document.createElement('span');

    let template = '<i class="fa fa-trash" aria-hidden="true" style="cursor: pointer;"></i>';
    element.innerHTML = template;
    element.addEventListener('click', () => {
      this.openWarning(userRole);
    });
    return element;
  }

  openWarning(userRole: any) {
    let dialogRef = this.dialogWarning.open(WarningPopupComponent, {
      height: '27%',
      width: '35%',
      autoFocus: false,
      data: userRole
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getAllUserRoles(userRole.data.botConfigId);
    })
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout("autoHeight");
  }

  onRoleSelectionChange() {
    const selectedRoles = this.Role.value as string[];
    const isCMSelected = selectedRoles.includes('Chat Manager');
    const areSAndASelected = selectedRoles.includes('Senior Agent') || selectedRoles.includes('Agent');

    if (isCMSelected) {
      if (selectedRoles.includes('Senior Agent') || selectedRoles.includes('Agent')) {
        const updatedRoles = selectedRoles.filter(role => role !== 'Senior Agent' && role !== 'Agent');
        this.Role.setValue(updatedRoles);
      }
    }
    else if (areSAndASelected) {
      if (selectedRoles.includes('Chat Manager')) {
        const updatedRoles = selectedRoles.filter(role => role !== 'Chat Manager');
        this.Role.setValue(updatedRoles);
      }
    }
  }

}
